import { ReactNode, createContext, useContext } from 'react';

interface BackendAdapterService {
  invoke: InvokeSignature;
}

export type InvokePayload = {
  [key in number | string]: unknown;
};

const BackendAdapterContext = createContext<BackendAdapterService | null>(null);

export const useBackendAdapter = () => {
  const context = useContext(BackendAdapterContext);
  if (!context) {
    throw new Error(
      'useBackendAdapter must be used within a BackendAdapterProvider'
    );
  }
  return context;
};

// TODO make type params not optional
export type InvokeSignature = <T = unknown, U = InvokePayload>(
  action: string,
  data?: U
) => Promise<T | undefined>;

interface BackendAdapterProviderProps {
  children: ReactNode;
  invokeImplementation: InvokeSignature;
}

export function BackendAdapterProvider({
  children,
  invokeImplementation,
}: BackendAdapterProviderProps) {
  return (
    <BackendAdapterContext.Provider value={{ invoke: invokeImplementation }}>
      {children}
    </BackendAdapterContext.Provider>
  );
}
